export default __webpack_public_path__ + "static/media/login-back-new.2f50d2ad.jpg";